/**
 * DebugTraceEvent — Individual event row in the debug trace timeline
 */

import React from 'react';
import { EVENT_CONFIG, formatDuration, formatEventData } from './DebugTraceUtils';
import { IconQuestionMark } from '@tabler/icons-react';
import { useAgentsFlow } from '../contexts/AgentsFlowContext';

const DebugTraceEvent = ({ event, nodeLabel, resolvedNodeId }) => {
  const { setHighlightedNodeId } = useAgentsFlow();

  const config = EVENT_CONFIG[event.event_type] || {
    icon: IconQuestionMark,
    color: '#9ca3af',
    label: event.event_type,
  };

  const Icon = config.icon;
  const summary = formatEventData(event);
  const duration = formatDuration(event.duration_ms);
  const depth = event.depth ?? 0;

  // Badge clicável do nó aparece SOMENTE em "Entrou no nó". Nos demais eventos
  // (Prompt montado, Chamada LLM, Resposta LLM, Tool chamada, Resultado tool, etc.)
  // o nome do nó é redundante e poluía o trace.
  const showNodeBadge = nodeLabel && event.event_type === 'node.enter';

  // Quando a badge aparece, o summary do node.enter (que também é o node_label)
  // ficaria duplicado — suprimir nesse caso.
  const showSummary = summary && !showNodeBadge;

  const handleBadgeClick = (e) => {
    e.stopPropagation();
    if (resolvedNodeId) setHighlightedNodeId(resolvedNodeId);
  };

  return (
    <div
      className="debug-trace-event"
      style={{ paddingLeft: `${12 + depth * 20}px` }}
    >
      <span className="debug-trace-event__icon" style={{ color: config.color }}>
        <Icon size={14} />
      </span>
      <span className="debug-trace-event__label" style={{ color: config.color }}>
        {config.label}
      </span>
      {showNodeBadge && (
        <button
          type="button"
          className="debug-trace-event__node-badge"
          title={`Ir para o nó: ${nodeLabel}`}
          onClick={handleBadgeClick}
        >
          {nodeLabel}
        </button>
      )}
      {showSummary && (
        <span className="debug-trace-event__data" title={summary}>
          {summary}
        </span>
      )}
      {duration && (
        <span className="debug-trace-event__duration">{duration}</span>
      )}
    </div>
  );
};

export default DebugTraceEvent;
